import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ overline, title, subtitle, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-14`}>
    {overline && (
      <span className="text-sm tracking-widest uppercase font-semibold text-strawberry">{overline}</span>
    )}
    <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-medium text-chocolate leading-tight">{title}</h2>
    {subtitle && <p className="mt-4 text-base sm:text-lg text-cocoa leading-relaxed">{subtitle}</p>}
  </div>
);
